<script setup lang="ts">

const props = defineProps<{
  title: string,
  param: string,
  paramValue: string,
  showClose: boolean,
  hideTitle?: boolean,
  width?: number
}>();

const emits = defineEmits<{
  (e: 'closed'): void
}>()

const router = useRouter();
const route = useRoute()

const isActive = computed(() => {
  return route.query[props.param] as string | null === props.paramValue
})
const close = () => {
  router.push({query: {
    [props.param]: undefined
    }})
  emits('closed')
}

</script>
<template>
  <InstantDialog v-if="isActive" :title="title" @closed="close" :showClose="showClose" :width="width" :hide-title="hideTitle">
    <slot></slot>
  </InstantDialog>
</template>
